import { useLocation, useNavigate } from "react-router-dom";
import SuccessScreen from "../../Common/SuccessScreen";

export const CompleteBuyerOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const role = location.state?.role;

  const filledButtonAction = () => navigate("/inventory");
  const outlinedButtonAction = () => navigate("/");

  return (
    <SuccessScreen
      title="Successfully Onboarded & e-KYC Verified!"
      subtitle={`${role} has been onboarded successfully. They will appear in your network.`}
      filledButtonLabel="Sell Products"
      filledButtonAction={filledButtonAction}
      OutlinedButtonLabel="Home"
      OutlinedButtonAction={outlinedButtonAction}
      buttonContainerWidth={{ xs: "100%", sm: "565px" }}
    />
  );
};

export default CompleteBuyerOnboarding;
